<div class="auto-size" #autoSize>
  <ng-container *ngIf="hasPagination; else noPagination">
    <ng-container *ngIf="!matStyle; else cdkStyle"></ng-container>

    <ng-container *ngIf="hasNgxPaginator; else matPaginator">
      <pagination-controls
        [responsive]="true"
        (pageChange)="ngxPageChanged.emit($event)"
        previousLabel="Anterior"
        nextLabel="Proxima"
      >
      </pagination-controls>
    </ng-container>

    <ng-template #matPaginator>
      <mat-paginator
        bsTablePaginator
        [hasPagination]="hasPagination"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
      ></mat-paginator>
    </ng-template>
  </ng-container>

  <ng-template #noPagination>
    <ng-container *ngIf="!matStyle; else cdkStyle"> </ng-container>
  </ng-template>
</div>

<ng-template #cdkStyle>
  <div
    class="table-scroll-container"
    [class.table-scroll-container--sticky-header]="floatHeader"
    #tableScrollContainer
  >
    <table
    bsTableOrchestrator
    #tableResizingInstance="tableResizingInstance"
    [tableOrchestratorPaginatorRef]="paginator"
    [bsAutomaticTableResizing]="automaticTableResizing"
    [bsAutomaticTableResizingDisplayColumns]="columnsToDisplay"
    #tableOrchestrator="tableOrchestrator"
    [tableOrchestratorDataSource]="dataSource"
    [tableOrchestratorHasAction]="hasAction"
    [tableOrchestratorColumnsToDisplay]="tableResizingInstance.autoSizeColumns"
    [tableOrchestratorElementKeys]="elementKeys"
    [tableOrchestratorExpandedElementViewMedia]="expandedElementViewMedia"
    [tableOrchestratorMediaIfDirective]="mediaIfDirective"
    [tableOrchestratorExpandedDetailQueryList]="expandedDetailQueryList"
    [tableOrchestratorActionQueryList]="actionQueryList"
    [tableOrchestratorChangeDetectorRef]="changeDetectorRef"
    [tableOrchestratorAutoSize]="autoSizeDirective"
    [tableOrchestratorHasServerSidePagination]="hasServerSidePagination"
    [tableOrchestratorPageChanged]="pageChanged"
    [tableOrchestratorEventAction]="eventAction"
    cdk-table
    multiTemplateDataRows
    [dataSource]="tableOrchestrator.matTableDataSource"
    [class.has-footer]="footerValues"
  >
    <ng-container
      *ngIf="
        tableOrchestrator.matTableDataSource &&
        tableOrchestrator.matTableDataSource.data
      "
    >
      <ng-container
        *ngFor="
          let item of tableOrchestrator.matTableDataSource.data
            | paginate
              : {
                  itemsPerPage: itemsPerPage,
                  currentPage: currentPage,
                  totalItems: totalItems
                }
        "
      ></ng-container>
    </ng-container>

    <ng-container
      [cdkColumnDef]="column"
      *ngFor="
        let column of tableOrchestrator.tableOrchestratorColumnsToDisplay;
        let index = index
      "
    >
      <th cdk-header-cell *cdkHeaderCellDef>{{ column }}</th>
      <td cdk-footer-cell *cdkFooterCellDef>
        {{ footerValues?.[column] }}
      </td>
      <td cdk-cell *cdkCellDef="let element">
        <span
          bsAutoAbbrev
          [hasCustomDom]="!!columnsOptions[index] && columnsOptions[index].customDom"
          class="text-overflow"
          [bsClickableCell]="columnsOptions[index].cellIsClickable ?? false"
          [clickableCellColor]="columnsOptions[index].highlightColor"
          [clickableCellUrl]="columnsOptions[index].url"
          [clickableCellWeight]="columnsOptions[index].fontWeight"
          [clickableElementData]="element"
          [clickableCellQueryParams]="columnsOptions[index].queryParamsFn"
          [clickableCellClickFn]="columnsOptions[index].clickableCellClickFn"
          [class]="
            element[tableOrchestrator.dataKeys[index]]
              ? element[tableOrchestrator.dataKeys[index]].toString()
              : 'primary-class'
          "
        >
        <ng-container *ngIf="columnsOptions[index]?.customDom && columnsOptions[index].template">
          <ng-container *ngTemplateOutlet="columnsOptions[index].template!; context: { element: element }"></ng-container>
        </ng-container>

        <span
          class="text"
          *ngIf="
            !columnsOptions[index]?.customDom &&
            (columnsOptions[index]?.columnType === 'text' ||
            !columnsOptions[index]?.columnType)
          "
        >    
            {{
              columnsOptions[index].typePipe
                ? (element[tableOrchestrator.dataKeys[index]]
                  | genericPipe
                    : columnsOptions[index].typePipe
                    : columnsOptions[index].typePipeParams)
                : element[tableOrchestrator.dataKeys[index]]
            }}
          </span>
          <img
            *ngIf="columnsOptions[index]?.columnType === 'image'"
            [bsNoImageFound]="noImage"
            [src]="element[tableOrchestrator.dataKeys[index]]"
            class="image"
          />
        </span>
      </td>
    </ng-container>

    <ng-container cdkColumnDef="actions">
      <th cdk-header-cell *cdkHeaderCellDef></th>
      <td cdk-cell *cdkCellDef="let element" (click)="$event.stopPropagation()">
        <div class="td-actions" style="cursor: pointer">
          <div #actionCellViewContainerRef></div>
        </div>
      </td>
      <td cdk-footer-cell *cdkFooterCellDef="let element"></td>
    </ng-container>

    <tr
      bsClickableRow
      [bsExpandedRow]="expandedElementViewMedia"
      [bsClickableRowFn]="clickableRowFn"
      [bsClickableRowParam]="element"
      [tableElement]="element"
      cdk-row
      *cdkRowDef="let element; columns: tableOrchestrator.tableColumns"
      class="element-row"
    ></tr>
    <tr
      cdk-header-row
      *cdkHeaderRowDef="tableOrchestrator.tableColumns; sticky: floatHeader"
    ></tr>
    <tr
      cdk-footer-row
      *cdkFooterRowDef="tableOrchestrator.tableColumns; sticky: floatFooter"
    ></tr>

    <ng-container
      *ngIf="expandedDetailQueryList && expandedDetailQueryList.length > 0"
    >
      <ng-container *bsMediaIf="expandedElementViewMedia; mode: 'lt'">
        <ng-container cdkColumnDef="expandedDetail">
          <td cdk-cell *cdkCellDef="let element">
            <div
              bsAutoSize
              [@detailExpand]="
                element === tableOrchestrator.expandedElement
                  ? 'expanded'
                  : 'collapsed'
              "
              class="element-detail"
            >
              <div #expandedDetailViewContainerRef></div>
            </div>
          </td>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="expandedDetailQueryList && expandedDetailQueryList.length > 0"
      >
        <tr
          cdk-row
          *cdkRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
        ></tr>
      </ng-container>
    </ng-container>
    </table>
  </div>
</ng-template>

<ng-template #matStyle>
  <div
    class="table-scroll-container"
    [class.table-scroll-container--sticky-header]="floatHeader"
    #tableScrollContainer
  >
    <table
    bsTableOrchestrator
    #tableResizingInstance="tableResizingInstance"
    [tableOrchestratorPaginatorRef]="paginator"
    [bsAutomaticTableResizing]="automaticTableResizing"
    [bsAutomaticTableResizingDisplayColumns]="columnsToDisplay"
    #tableOrchestrator="tableOrchestrator"
    [tableOrchestratorDataSource]="dataSource"
    [tableOrchestratorHasAction]="hasAction"
    [tableOrchestratorColumnsToDisplay]="tableResizingInstance.autoSizeColumns"
    [tableOrchestratorElementKeys]="elementKeys"
    [tableOrchestratorExpandedElementViewMedia]="expandedElementViewMedia"
    [tableOrchestratorMediaIfDirective]="mediaIfDirective"
    [tableOrchestratorExpandedDetailQueryList]="expandedDetailQueryList"
    [tableOrchestratorActionQueryList]="actionQueryList"
    [tableOrchestratorChangeDetectorRef]="changeDetectorRef"
    [tableOrchestratorAutoSize]="autoSizeDirective"
    [tableOrchestratorEventAction]="eventAction"
    [tableOrchestratorHasServerSidePagination]="hasServerSidePagination"
    [tableOrchestratorPageChanged]="pageChanged"
    mat-table
    multiTemplateDataRows
    [dataSource]="tableOrchestrator.matTableDataSource"
    [class.has-footer]="footerValues"
  >
    <ng-container
      [matColumnDef]="column"
      *ngFor="
        let column of tableOrchestrator.tableOrchestratorColumnsToDisplay;
        let index = index
      "
    >
      <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
      <td mat-footer-cell *matFooterCellDef>
        {{ footerValues?.[column] }}
      </td>

      <td mat-cell *matCellDef="let element">
        <span
          bsAutoAbbrev
          [hasCustomDom]="!!columnsOptions[index] && columnsOptions[index].customDom"
          class="text-overflow"
          [bsClickableCell]="columnsOptions[index].cellIsClickable ?? false"
          [clickableCellColor]="columnsOptions[index].highlightColor"
          [clickableCellUrl]="columnsOptions[index].url"
          [clickableCellWeight]="columnsOptions[index].fontWeight"
          [clickableElementData]="element"
          [clickableCellQueryParams]="columnsOptions[index].queryParamsFn"
          [clickableCellClickFn]="columnsOptions[index].clickableCellClickFn"
          [class]="
            element[tableOrchestrator.dataKeys[index]]
              ? element[tableOrchestrator.dataKeys[index]].toString()
              : 'primary-class'
          "
        >
          <span class="text">
            {{
              columnsOptions[index].typePipe
                ? (element[tableOrchestrator.dataKeys[index]]
                  | genericPipe
                    : columnsOptions[index].typePipe
                    : columnsOptions[index].typePipeParams)
                : element[tableOrchestrator.dataKeys[index]]
            }}
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
        <div class="td-actions" style="cursor: pointer">
          <div #actionCellViewContainerRef></div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef="let element"></td>
    </ng-container>

    <tr
      [bsExpandedRow]="expandedElementViewMedia"
      [tableElement]="element"
      bsClickableRow
      [bsClickableRowFn]="clickableRowFn"
      [bsClickableRowParam]="element"
      mat-row
      *matRowDef="let element; columns: tableOrchestrator.tableColumns"
      class="element-row"
    ></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="tableOrchestrator.tableColumns; sticky: floatHeader"
    ></tr>
    <tr
      mat-footer-row
      *matFooterRowDef="tableOrchestrator.tableColumns; sticky: floatFooter"
    ></tr>

    <ng-container
      *ngIf="expandedDetailQueryList && expandedDetailQueryList.length > 0"
    >
      <ng-container *bsMediaIf="expandedElementViewMedia; mode: 'lt'">
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element">
            <div
              bsAutoSize
              [@detailExpand]="
                element === tableOrchestrator.expandedElement
                  ? 'expanded'
                  : 'collapsed'
              "
              class="element-detail"
            >
              <div #expandedDetailViewContainerRef></div>
            </div>
          </td>
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="expandedDetailQueryList && expandedDetailQueryList.length > 0"
      >
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
        ></tr>
      </ng-container>
    </ng-container>
    </table>
  </div>
</ng-template>
